var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"analytics-page mb-2"},[_c('div',{staticClass:"chart-container"},[_c('div',{attrs:{"id":"chart"}},[_c('apexchart',{key:_vm.chartKey,attrs:{"type":"bar","height":"350","options":_vm.chartOptions,"series":_vm.series}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }